<div
  (click)="menu.toggle($event)"
  class="flex items-center gap-2 cursor-pointer"
>
  <p-avatar [image]="baseUrl + userData().photo" class="" shape="circle" />
  <div class="hidden xl:block">
    <div class="text-sm">{{ username() }}</div>
    <div class="text-xs text-gray-500">{{ email() }}</div>
  </div>
</div>
<p-menu #menu [model]="items" [popup]="true" appendTo="body" dir="rtl">
  <ng-template #item let-item>
    @if (item.route) {

    <a
      [routerLink]="item.route"
      class="p-menu-item-link flex items-center gap-2"
    >
      <span ngClass="text-sm" [class]="item.icon"></span>
      <span class="text-sm">{{ item.label }}</span>
    </a>

    } @else {

    <a
      (click)="item.command()"
      class="p-menu-item-link flex items-center gap-2 text-sm"
    >
      <span [class]="item.icon"></span>
      <span>{{ item.label }}</span>
    </a>

    }
  </ng-template>

  <p-confirmDialog [draggable]="false" key="cofirm-logout"></p-confirmDialog>
</p-menu>
